import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  DISPOSAL_TYPES,
  type DisposalFilters,
  type DisposalType,
} from '@/features/inventory-disposals/api'
import { DisposalsScreen } from '@/features/inventory-disposals/disposals-screen'
import { hasGrant } from '@/lib/me'

const text = (value: unknown) => (typeof value === 'string' && value ? value : undefined)
const positive = (value: unknown) => {
  const number =
    typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : Number.NaN
  return Number.isInteger(number) && number > 0 ? number : undefined
}

export const Route = createFileRoute('/_authenticated/inventory/disposals')({
  validateSearch: (search: Record<string, unknown>): DisposalFilters => ({
    type: DISPOSAL_TYPES.find((type: DisposalType) => type === search.type),
    warehouse: text(search.warehouse),
    q: text(search.q),
    page: positive(search.page),
    perPage: positive(search.perPage),
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'stock.view')) throw redirect({ to: '/' })
  },
  component: InventoryDisposalsRoute,
})

function InventoryDisposalsRoute() {
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <DisposalsScreen
      params={Route.useSearch()}
      onParamsChange={(next) => void navigate({ search: next })}
    />
  )
}
